// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"F8-z"};